export enum EntityType {
  Carrier = "C",
  Shipper = "S",
  Broker = "B",
  Registrant = "R",
  FreightForwarder = "F",
  CargoTank = "T",
  IntermodalEquipmentProvider = "I",
}
